import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { PendingApprovalService } from 'app/about/pending-approval/pending-approval-service.service';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(
    private router: Router,
    private auth: AuthService,
    private pendingApprovalService: PendingApprovalService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // 1. Verify Active Server Session
    return this.auth.checkServerLogin().pipe(
      switchMap((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          this.auth.logout();
          this.auth.setRedirectURL(state.url);
          this.router.navigate(['/login']);
          return of(false);
        }

        const currentCookie = this.auth.getFullCookie();
        if (!currentCookie) {
          this.router.navigate(['/login']);
          return of(false);
        }

        const userId = this.auth.getUserId();

        if (!currentCookie['token']) {
          this.router.navigate([`termsandconditions/${userId}`]);
          return of(false);
        }

        if (currentCookie['isMultiCliLogin'] && !this.auth.getUserOrgId() && !state.url.includes('/accounts')) {
          this.router.navigate(['/accounts']);
          return of(false);
        }

        const selectedOrgId = this.auth.getUserOrgId();

        const companyAccounts: any[] = currentCookie['CompanyAccounts'] || [];
        let activeCompanyAccount = null;

        if (selectedOrgId && companyAccounts.length > 0) {
          activeCompanyAccount = companyAccounts.find(
            acc => acc.Organization_ID === selectedOrgId
          );
        }

        if (!activeCompanyAccount && companyAccounts.length > 0) {
          activeCompanyAccount = companyAccounts[0];
        }

        return this.pendingApprovalService.checkIfOnboardingComplete(activeCompanyAccount).pipe(
          map((res: any) => {
            const isOnboardingComplete = res && res.isOnboardingComplete;

            if (!isOnboardingComplete) {
              // Redirect unapproved user away from protected routes
              if (!state.url.includes('/pendingApproval')) {
                this.router.navigate([`pendingApproval/${userId}`]);
                return false;
              }
              return true;
            } else {
              // Block approved users from navigating back into pendingApproval screen
              if (state.url.includes('/pendingApproval')) {
                this.router.navigate(['/orders/current']);
                return false;
              }
              return true;
            }
          }),
          catchError(() => {
            this.router.navigate(['/login']);
            return of(false);
          })
        );
      }),
      catchError(() => {
        this.auth.logout();
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}